import * as React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'
import { Input, InputProps } from '~/components/input/Input'

type InputFieldProps = InputProps & FieldElementWrapperProps

export const InputField = ({
  className,
  label,
  name,
  validation,
  prompt,
  description,
  hideLabel,
  appearance,
  theme,
  ...remainingProps
}: InputFieldProps) => {
  const { register } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)

  const ref = validation ? register(validation) : register
  const formAppearance = context?.appearance || appearance
  const formTheme = context?.theme ?? theme

  return (
    <FieldWrapper
      className={className}
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
      appearance={formAppearance}
    >
      <Input
        id={name}
        name={name}
        ref={ref}
        appearance={formAppearance}
        theme={formTheme}
        {...(error && { state: 'error' })}
        {...remainingProps}
      />
    </FieldWrapper>
  )
}

InputField.displayName = 'InputField'
